import { getCookie } from '../cookie/get-cookie';

export const isLoggedIn = () => {
    return !!getCookie('isLoggedIn');
};
